import { Map } from 'immutable';

import * as constants from './constants';
import * as types from './types';

const initialState = Map({
  resto: constants.STATUS_PENDING,
  userService: constants.STATUS_PENDING,
  encore: constants.STATUS_PENDING,
});

const treat4xxAs2xx = (status) => (
  (status >= 500) ? constants.STATUS_FAILED : constants.STATUS_OK
);

const backendReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.HEALTH_CHECK_ENCORE.SUCCESS:
      return state.set('encore', constants.STATUS_OK);
    case types.HEALTH_CHECK_RESTO.SUCCESS:
      return state.set('resto', constants.STATUS_OK);
    case types.HEALTH_CHECK_USERSERVICE.SUCCESS:
      return state.set('userService', constants.STATUS_OK);
    case types.HEALTH_CHECK_ENCORE.FAILURE:
      return state.set('encore', treat4xxAs2xx(payload.response.status));
    case types.HEALTH_CHECK_RESTO.FAILURE:
      return state.set('resto', treat4xxAs2xx(payload.response.status));
    case types.HEALTH_CHECK_USERSERVICE.FAILURE:
      return state.set('userService', treat4xxAs2xx(payload.response.status));
    case types.CLEANUP:
      return initialState;
    default:
      return state;
  }
};

export default backendReducer;
export { initialState };
